'use client'

import { useQuery } from '@tanstack/react-query'

import { GetHeaderElementViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'

import { LayoutReactQueryKeys } from '../../types'

export const useGetHeaderBanner = () => {
    return useQuery<GetHeaderElementViewModel>({
        queryKey: [LayoutReactQueryKeys.HeaderBanner],
        queryFn: () => fetchRequest({ endpoint: '/header-elements', method: 'GET', serviceName: 'cml' }),
        refetchOnMount: true,
        staleTime: 0,
    })
}
